import { Tooltip } from "bootstrap";

export default class CopyLink {
  constructor(node) {
    this.element = node;
    this.timeout;

    this.textToCopyElement = this.element.querySelector(".js-copy-link-text-to-copy");
    this.toolTipElement = this.element.querySelector(".js-tooltip");
    this.copiedText = this.element.dataset.copiedText;
    this.copyElement = this.element;

    this.initialize();
  }

  initialize() {
    if (this.toolTipElement) {
      this.defaultText = this.toolTipElement.dataset.bsTitle;
      this.copyElement = this.toolTipElement;

      this.tooltip = Tooltip.getOrCreateInstance(this.toolTipElement);
    } else {
      this.defaultText = this.element.dataset.defaultText;
      this.buttonTextElement = this.element.querySelector(".js-copy-link-text");
    }

    this.copyElement.addEventListener("click", () => {
      clearTimeout(this.timeout);

      navigator.clipboard.writeText(this.textToCopyElement ? this.textToCopyElement.innerText : window.location.href);

      this.setCopyFeedbackText(this.copiedText);

      this.timeout = setTimeout(() => {
        this.setCopyFeedbackText(this.defaultText);
      }, 1000);
    });
  }

  setCopyFeedbackText(text) {
    this.toolTipElement ? this.tooltip.setContent({ ".tooltip-inner": text }) : (this.buttonTextElement.innerText = text);
  }
}
